import localization from '../localization';
import stateManager from '../state';

export const isEditMode = () => {
    const { isEditMode } = stateManager.store.getState();
    return isEditMode;
}
export default {
    payStubID: {
        isValid: (uuid) => (isEditMode()) ? true : uuid.length === 36,
        message: (lang) => (isEditMode()) ? '' : localization[lang].document_errors.pay_stub
    }
};
